import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'
import { cpaToolsToCegidIntegrationStatus } from '@features/invoices/elements/InvoicesList/constants/cpaToolsToCegidIntegrationStatus'
import { CpaToolsIntegrationStatus } from '@features/invoices/enums/cpaToolsIntegrationStatus'

export const getImportedInvoiceIntegrationStatus = (
  cpaToolsIntegrationStatus?: CpaToolsIntegrationStatus | null,
): CegidIntegrationStatus =>
  (cpaToolsIntegrationStatus ? cpaToolsToCegidIntegrationStatus[cpaToolsIntegrationStatus] : undefined) ??
  CegidIntegrationStatus.Pending
